import React, {PureComponent} from 'react';
import PieChart from '../../Chart/PieChart.js'
import DatePicker from 'react-datepicker'
import Popup from '../../Alert/Popup.js'
import { renderLoader } from "../../Loading/loading";
import {TrendData, Trend} from './Trend'
import {trendInterval, tiUpdate, arrApiAdapter, tiToString, tiRebase, tiExtent} from './TrendModel'
import SlidePicker from './SlidePicker'

import '../../Chart/ChartModal.css'
import './Trend.css'

export default class TrendPanel extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      errMsg: null,
      isLoading: true,
      loader: renderLoader(),
      render: 0,
      chartData: undefined,
      rangeValid: true,
      agoPeriod: 'Months'
    };
    this.ti = new trendInterval(this.props.startrange, {days:1}, {months:1})
    this.xaxis = []
    this.series1 = []
    this.handleClose = this.handleClose.bind(this);
  }

  async componentDidMount () {
    //console.log (this.props)
    if (!this.state.isLoading)
      this.setState({isLoading:true})
    const pr = TrendData(this.props, this.ti, this.props.deviceId)
    pr.then ((result) => {
      const cd = this.trendToChart(this.scale(Trend(arrApiAdapter(result), this.ti)))
      this.setState({chartData: cd, rangeValid: true, isLoading:false})
    })
    pr.catch((err) => {
      console.log (err)
      this.setState({isLoading:false})
    })
  }
  scale(trend) {
    trend[0].forEach((tr, index) => {
      const strFactor = this.props?.deviceConfig?.sensors[index]?.factor
      const factor = isNaN(parseFloat(strFactor)) ? 1 : parseFloat(strFactor)
      trend[0][index].delta *= factor
      trend[1][index].delta *= factor 
    })
    return trend
  }
  trendToChart (trend) {
    if (!(Array.isArray(trend[1])&&trend[1].length > 0)) {
      return trend[0].map((item, index)=>({sensorType: item.sensorType, d1: item.delta, d2:0}))
    }
    const cdata = trend[0].map ((item, index)=>({sensorType: item.sensorType, d1: item.delta, d2:trend[1][index].delta}))
    // console.log (cdata)
    return cdata
  }
  handleClose() {
    this.props.hide();
  }
  dateChange = (date) => {
    console.log (date)
    tiRebase(this.ti, date)
    this.componentDidMount()
  }
  rangeChange = (event) => {
    const entry = event.target.value
    if (entry>0 && entry < 32) {
      tiUpdate(this.ti, {days:entry})
      this.componentDidMount()
    }
    else this.setState({rangeValid: false})
  }
  agoChange = (event) => {
    tiExtent(this.ti, {months:event.target.value})
    this.componentDidMount()
  }
  agoPeriod = (unit) => {
    const ago = Object.values(this.ti.ago)
    const lunit = unit.toLowerCase()
    const dbg = {[lunit]: ago[0]}
    console.log (dbg)
    tiExtent(this.ti, {[lunit]:ago[0]})
    this.setState ({agoPeriod:unit})
  }
  render() {
    //console.log (tiToString(this.ti))
    if (this.state.isLoading)
      return <div className="tloading">{this.state.loader}</div>
    if (this.state.errMsg)
      return <Popup popupMsg={this.state.errMsg} />
    if (!this.state.chartData)
        return null
    const days = this.ti.duration.days
    const dispDate = this.ti.later.s.toJSDate()
    const ago = this.ti.ago.months
    const rangeStyle = this.state.rangeValid ? 'inRange' : 'outtaRange'
    return (
      <section className="tpanel">
        <div className="chart-slide narrow flex-left"> 
          <PieChart labels={tiToString(this.ti)} units="Gallons" legend={{position: 'left', display: true}}
            data={[this.state.chartData[0].d1, this.state.chartData[0].d2]}/>
        </div>
        <div className="flex-right">
          Compare 
          <input className={'numInput col-space '+rangeStyle} type='number' value={days} onChange={this.rangeChange} min={1} max={31}/> Days
          <br/>Starting&nbsp;
          <DatePicker className="date-input line-space" selected={dispDate} 
            onChange={this.dateChange} dateFormat="MMM d, yyyy" 
            maxDate={this.props.startrange}/><br/>
          To
          <input className='numInput col-space inRange' type='number' value={ago} onChange={this.agoChange} min={1} max={24} />
           <SlidePicker onUpdate={this.agoPeriod} value={0} settings={['Months', 'Weeks']} />
           Ago
        </div>
      </section>
    );
  }
}
